// Presence is site membership; a missing game-roster link must not hide a user.
// Unlinked users remain display-only and never become practice/attack targets.
export function onlineRaidMembers(roster = [], present = []) {
  const byUser = new Map(roster.filter(row => row.userId).map(row => [row.userId, row]));
  const seen = new Set();
  return present.filter(row => row.userId && !seen.has(row.userId) && seen.add(row.userId)).map(row => ({
    ...byUser.get(row.userId),
    userId: row.userId,
    memberOpenid: byUser.get(row.userId)?.memberOpenid || '',
    nickname: row.nickname || byUser.get(row.userId)?.nickname || '멤버',
    avatarUrl: row.avatarUrl || byUser.get(row.userId)?.avatarUrl || '',
    online: true,
  }));
}
